import React from "react";
import lentera from "../assets/svg/lentera-icon.svg";
import "../styles/CommonFooter.css";

const CommonFooter = () => {
  return (
    <footer className="common-footer">
      <span>{new Date().getFullYear()} © Powered by</span>
      <a href="https://lenteratech.com/" target="_blank" rel="noreferrer">
        <img src={lentera} alt="Lentera" />
      </a>
    </footer>
  );
};

export default CommonFooter;
